// 3s per block, so 20 blocks gives 1 minutes
export const MAX_LEDGER_VERSION_OFFSET = 20

export const DEST_TAG_MAX_NUMBER = 0xff_ff_ff_ff

export const RESERVE_BASE = 1

export const RESERVE_INC = 0.2

export const BLOCK_INTERVAL = 3 * 1.5 // 3s per block * 1.5 multipler

export const DELETE_ACCOUNT_MIN_BLOCKS = 256

// Ordering from https://developers.ripple.com/accountroot.html
const accountRootFlags = {
  // lsfDefaultRipple:
  // Enable rippling on trust lines by default.
  // Required for issuing addresses; discouraged for others.
  DefaultRipple: 0x00_80_00_00,

  // lsfDepositAuth:
  // Require account to auth deposits.
  // This account can only receive funds from transactions it sends,
  // or preauthorized accounts.
  DepositAuth: 0x01_00_00_00,

  // lsfDisableMaster:
  // Force regular key.
  // Disallows use of the master key.
  DisableMaster: 0x00_10_00_00,

  // lsfDisallowXRP:
  // Disallow sending XRP.
  // Not enforced by rippled; client applications should check.
  DisallowXRP: 0x00_08_00_00,

  // lsfGlobalFreeze:
  // Trustlines globally frozen.
  GlobalFreeze: 0x00_40_00_00,

  // lsfNoFreeze:
  // Permanently disallowed freezing trustlines.
  // Once enabled, cannot be disabled.
  NoFreeze: 0x00_20_00_00,

  // lsfPasswordSpent:
  // Password set fee is spent.
  // The account has used its free SetRegularKey transaction.
  PasswordSpent: 0x00_01_00_00,

  // lsfRequireAuth:
  // Require authorization to hold IOUs (issuances).
  RequireAuth: 0x00_04_00_00,

  // lsfRequireDestTag:
  // Require a DestinationTag for incoming payments.
  RequireDestTag: 0x00_02_00_00,
}

export const AccountFlags = {
  passwordSpent: accountRootFlags.PasswordSpent,
  requireDestinationTag: accountRootFlags.RequireDestTag,
  requireAuthorization: accountRootFlags.RequireAuth,
  depositAuth: accountRootFlags.DepositAuth,
  disallowIncomingXRP: accountRootFlags.DisallowXRP,
  disableMasterKey: accountRootFlags.DisableMaster,
  noFreeze: accountRootFlags.NoFreeze,
  globalFreeze: accountRootFlags.GlobalFreeze,
  defaultRipple: accountRootFlags.DefaultRipple,
}

// https://github.com/ripple/ripple-lib/blob/0.22.0/src/common/txflags.ts#L9
export const AccountSetFlags = {
  asfRequireDest: 1,
  asfRequireAuth: 2,
  asfDisallowXRP: 3,
  asfDisableMaster: 4,
  asfAccountTxnID: 5,
  asfNoFreeze: 6,
  asfGlobalFreeze: 7,
  asfDefaultRipple: 8,
  asfDepositAuth: 9,
}

export const ADDRESSES_NOT_SUPPORT_DELETE = [
  'rEb8TK3gBgk5auZkwc6sHnwrGVJH8DuaLh', // Binance
  'rLHzPsX6oXkzU2qL12kHCH8G8cnZv1rBJh', // Kraken
  'rDsbeomae4FXwgQTJp9Rs64Qg9vDiTCdBv', // Bitstamp
  'raSLkv529QyqKAPLK1z3mDsNa8a6RLt2ok', // CoinDCX
  'r9W43TLGwcRChnHaQPoSBUMWe9CbQXeMrr', // SwissBorg
]

export const TransactionTypes = {
  AccountDelete: 'AccountDelete', // Deletes an account and transfers remaining XRP to another account
  AccountSet: 'AccountSet', // Updates account settings like flags and domains

  Payment: 'Payment', // Transfers XRP or issued tokens between accounts

  SetRegularKey: 'SetRegularKey', // Assigns or changes a regular key for the account
  TrustSet: 'TrustSet', // Creates, modifies, or removes a trust line for issued currencies
}
